import axios from "axios";
import { CORREO_USUARIO } from "config/general/Configuracion";
import { API_CONFIGURACION } from "config/general/Configuracion";
import { SESION } from "config/general/Configuracion";
import { ID_PERFIL } from "config/general/Configuracion";
import { ID_CUENTA } from "config/general/Configuracion";
import { API_MESA_AYUDA, HEADERS, apiTimeout } from "config/general/Configuracion";


const MesaDeAyudaApiHelper = {
  
    listarSolicitudes: async (cuenta, limite = 100, actual = 1) => {
        try {
            const url = `${API_MESA_AYUDA}/v1/mesaAyuda/listado/${cuenta}?limite=${limite}&actual=${actual}`;
            const response = await axios.get(url, {
                headers: HEADERS(),
                timeout: apiTimeout
            });
            return response.data;
        } catch (error) {
            console.error("Error al listar solicitudes:", error);
            throw error;
        }
    },

    guardarSolicitud: async (cuenta, solicitud) => {
        try {
            const url = `${API_MESA_AYUDA}/v1/mesaAyuda/guardar/${cuenta}`;
            const response = await axios.post(url, solicitud,{
                headers: HEADERS(),
                timeout: apiTimeout
            });
            return response.data;
        } catch (error) {
            console.error("Error al guardar solicitud:", error);
            throw error;
        }
    },

    obtenerIdUsuario: async () => {
        try {
            const url = `${API_CONFIGURACION}/v1/configuracion/consultar_id_usuario/${sessionStorage[ID_CUENTA]}/${sessionStorage[CORREO_USUARIO]}`;
            const response = await axios.get(url, {
                headers: HEADERS(),
                timeout: apiTimeout
            });
            return response.data;
        } catch (error) {
            console.error("Error al obtener ID de usuario:", error);
            throw error;
        }
    },
};

export default MesaDeAyudaApiHelper;
